import Vue from 'vue'
import { pwdLogin, verifyCodeLogin, getStuInfo } from '@/api/user'
import store from '../index'
import { USER_INFO, ACCESS_TOKEN, QR_CODE } from '@/store/mutation-types'
// import { Message } from 'ant-design-vue'

const user = {
  state: {
    token: '',
    isAudition: true,
    userInfo: {}
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      Vue.ls.set(ACCESS_TOKEN, token)
    },
    SET_AUDITION(state, value) {
      // let isAudition = null
      // if (typeof value === 'string') {
      //   isAudition = !(value === '0')
      // }
      state.isAudition = (value === '0')
      Vue.ls.set('isAudition', (value === '0'))
    },
    SET_USER_INFO(state, data) {
      state.userInfo = data
      Vue.ls.set(USER_INFO, state.userInfo)
      // state.token = data.token
      // Vue.ls.set(ACCESS_TOKEN, state.token)
    },
    UPDATA_USER_INFO(state, data) {
      state.userInfo = Object.assign(state.userInfo, data)
      if (data.isAudition) {
        this.commit('SET_AUDITION', data.isAudition)
      }
      Vue.ls.set(USER_INFO, state.userInfo)
    }
  },
  actions: {
    async loginAsync({ commit }, data) {
      try {
        // console.log(store.state.system.orgInfo.ocode)
        const ocode = store.state.system.orgInfo.ocode
        let loginRes = null
        if (data.grant_type === 'stu_password') {
          loginRes = await pwdLogin({
            phoneNumber: data.username,
            password: data.password,
            ocode
          })
        } else {
          loginRes = await verifyCodeLogin({
            phoneNumber: data.mobile,
            smsCode: data.code,
            ocode
          })
        }
        if (!loginRes.token) {
          // Message.error(loginRes.message || '')
          return Promise.reject(loginRes.data || '')
        }
        // const { access_token: token } = await login({
        //   ...data,
        //   ocode
        // })
        const { accessToken: token } = loginRes.token
        commit('SET_TOKEN', token)
        const res = await getStuInfo()
        // delete loginRes.token
        commit('SET_USER_INFO', res)
        commit('SET_AUDITION', loginRes.isAudition || '')
        // console.log(res)
        // Vue.ls.set('isAudition', !(res.isAudition === '0'))
        // // commit('ACCESS_STUID', res.id)

        return Promise.resolve(true)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    logout({ commit }) {
      commit('SET_TOKEN', '')
      commit('SET_USER_INFO', {})
      Vue.ls.remove(ACCESS_TOKEN)
      Vue.ls.remove(USER_INFO)
      Vue.ls.remove(QR_CODE)
      // localStorage.removeItem('qrcodeUrl')
    }
  },
  getters: {
    getUserData(state) {
      console.log(state.userInfo, 'state.userInfo')
      return keys => {
        let data = {}
        if (typeof keys === 'string') {
          data[keys] = state.userInfo[keys]
        }
        if (Array.isArray(keys)) {
          if (!keys.length) {
            data = state.userInfo
          } else {
            keys.forEach(key => {
              data[key] = state.userInfo[key]
            })
          }
        }
        return data
      }
    }
  }
}
export default user
// // import { login, getInfo, logout } from '@/api/login'
// // import { logout } from '@/api/login'
// import { ACCESS_TOKEN } from '@/store/mutation-types'
// import { welcome } from '@/utils/util'
// const qs = require('querystring')

// const user = {
//   state: {
//     token: '',
//     name: '',
//     welcome: '',
//     avatar: '',
//     roles: [],
//     info: {}
//   },

//   mutations: {
//     SET_TOKEN: (state, token) => {
//       state.token = token
//     },
//     SET_NAME: (state, { name, welcome }) => {
//       state.name = name
//       state.welcome = welcome
//     },
//     SET_AVATAR: (state, avatar) => {
//       state.avatar = avatar
//     },
//     SET_ROLES: (state, roles) => {
//       state.roles = roles
//     },
//     SET_INFO: (state, info) => {
//       state.info = info
//     }
//   },

//   actions: {
//     // 登录
//     async Login({ commit }, userInfo) {
//       // hack for fack login
//       const search = qs.decode(location.search)
//       if (search.ignoreLogin) {
//         console.log(search)
//         const token = '4291d7da9005377ec9aec4a71ea837f'
//         Vue.ls.set(ACCESS_TOKEN, token, 7 * 24 * 60 * 60 * 1000)
//         commit('SET_TOKEN', token)
//         return true
//       }
//       const url = '/p/web/auth/login/username'
//       const rz = await Vue.axios.post(url, userInfo)
//       console.log('Rez', rz)
//       if (!rz) {
//         return false
//       }
//       Vue.ls.set(ACCESS_TOKEN, rz.access_token, 7 * 24 * 60 * 60 * 1000)
//       Vue.ls.set('USER_INFO', rz)
//       commit('SET_TOKEN', rz.access_token)
//       return rz
//     },

//     // 获取用户信息
//     GetInfo({ commit }) {
//       const result = require('@/mock/services/user').userInfo

//       if (result.role && result.role.permissions.length > 0) {
//         const role = result.role
//         role.permissions = result.role.permissions
//         role.permissions.map(per => {
//           if (per.actionEntitySet != null && per.actionEntitySet.length > 0) {
//             const action = per.actionEntitySet.map(action => { return action.action })
//             per.actionList = action
//           }
//         })
//         role.permissionList = role.permissions.map(permission => { return permission.permissionId })
//         commit('SET_ROLES', result.role)
//         commit('SET_INFO', result)
//       }

//       commit('SET_NAME', { name: result.name, welcome: welcome() })
//       commit('SET_AVATAR', result.avatar)
//       return true
//       // return new Promise((resolve, reject) => {
//       //   getInfo().then(response => {
//       //     const result = response.result

//       //     if (result.role && result.role.permissions.length > 0) {
//       //       const role = result.role
//       //       role.permissions = result.role.permissions
//       //       role.permissions.map(per => {
//       //         if (per.actionEntitySet != null && per.actionEntitySet.length > 0) {
//       //           const action = per.actionEntitySet.map(action => { return action.action })
//       //           per.actionList = action
//       //         }
//       //       })
//       //       role.permissionList = role.permissions.map(permission => { return permission.permissionId })
//       //       commit('SET_ROLES', result.role)
//       //       commit('SET_INFO', result)
//       //     } else {
//       //       reject(new Error('getInfo: roles must be a non-null array !'))
//       //     }

//       //     commit('SET_NAME', { name: result.name, welcome: welcome() })
//       //     commit('SET_AVATAR', result.avatar)

//       //     resolve(response)
//       //   }).catch(error => {
//       //     reject(error)
//       //   })
//       // })
//     },

//     // 登出
//     Logout({ commit, state }) {
//       commit('SET_TOKEN', '')
//       commit('SET_ROLES', [])
//       Vue.ls.remove(ACCESS_TOKEN)
//       // return new Promise((resolve) => {
//       //   logout(state.token).then(() => {
//       //     resolve()
//       //   }).catch(() => {
//       //     resolve()
//       //   }).finally(() => {
//       //     commit('SET_TOKEN', '')
//       //     commit('SET_ROLES', [])
//       //     Vue.ls.remove(ACCESS_TOKEN)
//       //   })
//       // })
//     }

//   }
// }
